
const SET_LIST = (state, schedule) => {
  state.list = schedule
}

const SET_AVAILABLEAPPOINTMENTS = (state, schedule) => {
  state.availableAppointments = schedule
}

export default {
  SET_LIST,
  SET_AVAILABLEAPPOINTMENTS
}



// WEBPACK FOOTER //
// ./src/store/modules/exam/mutations.js